var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.529.263a.76.76 0 0 1 .385-.23.76.76 0 0 1 .437 0 .83.83 0 0 1 .398.23.73.73 0 0 1 .219.386.76.76 0 0 1 0 .437.8.8 0 0 1-.219.385L1.478 19.746a.8.8 0 0 1-.386.218.8.8 0 0 1-.45 0 .8.8 0 0 1-.385-.218.76.76 0 0 1-.231-.386.94.94 0 0 1 0-.437.9.9 0 0 1 .231-.398zm1.22 18.262a.8.8 0 0 1 .219.398.94.94 0 0 1 0 .437.8.8 0 0 1-.219.386.76.76 0 0 1-.398.231.9.9 0 0 1-.45-.013.72.72 0 0 1-.372-.218L.257 1.47a.9.9 0 0 1-.231-.385.94.94 0 0 1 0-.437.8.8 0 0 1 .231-.386.76.76 0 0 1 .385-.23.76.76 0 0 1 .437 0 .76.76 0 0 1 .399.23z"
  })));
};
export default SvgClose;